class ProductPruchasesLog {
	constructor(amount, cost) {
		this.amount = amount;
		this.cost = cost;
	}

	toPlainObj() {
		return {
			amount: this.amount,
			cost: this.cost
		};
	}
};

export default function ProductPurchasesLogBuilder() {
	return {
		withAmount: function (amount) {
			this.amount = amount;
			return this;
		},
		withCost: function (cost) {
			this.cost = cost;
			return this;
		},
		build: function () {
			return new ProductPruchasesLog(this.amount, this.cost);
		}
	};
}
